import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import VxBasicInputField from '../vxFields/VxBasicInputField';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _includes from 'lodash/includes';
import { BTN_FACTORY_FORM, BTN_FACTORY_MAX_PROGRAMS, BTN_FACTORY_MAX_LENGTH_PROGRAMS } from '../../clientConstants';
import getLocaleMessages from '../../utils/localesMessages';

const {
	programsAdded,
	programName,
	removeButton,
	addButton
} = getLocaleMessages('buttons/wizardStepTwo');

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state) || {};

	return {
		programNames: formValues.programNames,
		newProgramName: formValues.newProgramName
	}
}

class AddRemovePrograms extends Component {
	static propTypes = {
		newProgramName: PropTypes.string,
		programNames: PropTypes.array,
		addProgram: PropTypes.func,
		removeProgram: PropTypes.func
	}

	handleAddProgramClick = () => {
		const newProgramName = this.props.newProgramName;
		this.props.addProgram(newProgramName);
	}

	handleRemoveProgramClick = (index) => {
		this.props.removeProgram(index);
	}

	renderPrograms = (props) => {
		const programNames = this.props.programNames;

		if (_isEmpty(programNames)) {
			return null;
		}

		return (
			<div className="programs-added">
				<div className="text-muted">{programsAdded}</div>
				{
					_map(programNames, (program, index) => {
						return (
							<div key={index} className="program-row">
								<div className="program-name-text">
									{program}
								</div>
								<div className="action-button">
									<button
										className="vx_btn-link"
										type="button"
										onClick={() => this.handleRemoveProgramClick(index)}
									>{removeButton}
									</button>
								</div>
							</div>
						)
					})
				}
			</div>

		)
	}

	showAddButton = (programNames, newProgramName) => {
		if (!newProgramName) {
			return false;
		}

		if (newProgramName.length > BTN_FACTORY_MAX_LENGTH_PROGRAMS) {
			return false;
		}

		if (programNames && programNames.length >= BTN_FACTORY_MAX_PROGRAMS) {
			return false;
		}

		return !_includes(programNames, newProgramName);
	}

	renderNewProgramName = (props) => {
		return (
			<VxBasicInputField
				{...props}
			/>
		)
	}

	render() {
		const programNames = this.props.programNames;
		const newProgramName = this.props.newProgramName;
		const showPrograms = programNames && programNames.length > 0;

		return (
			<div>
				<div className="program-row">
					<div className="program-name-field">
						<Field
							type="text"
							id="newProgramName"
							name="newProgramName"
							component={this.renderNewProgramName}
							label={programName}
						/>
					</div>
					{
						this.showAddButton(programNames, newProgramName) &&
						<div className="action-button">
							<button
								className="vx_btn-link"
								type="button"
								onMouseDown={this.handleAddProgramClick}
								id="addProgram"
							>{addButton}
							</button>
						</div>
					}
				</div>
				{
					showPrograms &&
						<Field
							id="programNames"
							name="programNames"
							component={this.renderPrograms}
							rerenderOnEveryChange={true}
						/>
				}
			</div>
		);
	}
}

export default connect(mapStateToProps)(AddRemovePrograms);



// WEBPACK FOOTER //
// ./buttons/components/programs/AddRemovePrograms.js